import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

const AppDetails = ({
  gameDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Game name"
          subtitle={gameDetails?.game_name ? gameDetails?.game_name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Active?"
          subtitle={gameDetails?.is_active ? 'Yes' : 'No'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
